<template>
  <div class="report-reason">
     <z-fix-top
      v-if="!isMainPage"
      keep-position
      class="fixtop"
      :style="{background: '#F7F7F7'}"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          :title="navTitle"
          @click-left="handleClickLeft"
      >
      </z-nav-bar>
    </z-fix-top>
    <div class="childContainer">
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { NavBar, FixTop } from '@zz-common/zz-ui';
import { queryParams } from '../../lib/utils'
import { getreportreasons } from '@api/resourceApi'
import { formatReason } from './logic'

const query = queryParams()
console.log('打印举报参数', query)

export default {
  name: 'ReportReason',
  data() {
    return {
      submitData: {},
      sharedData: {
        from: query.from || this.$route.query.from, // 举报来源1商品页 2用户页 3私信页 4私信页策略举报链接 5视频 6图片 7短视频 8url 9帖子 10补充举报(补充举报已经废弃，现在按成普通举报处理) 11直播 12放心转
        toUid: query.bereporteduid || this.$route.query.bereporteduid, //用户uid
        infoId: query.infoid || this.$route.query.infoid, //信息uid
        postId: query.postId || this.$route.query.postId, //帖子uid
        videoId: query.videoId || this.$route.query.videoId, //视频uid
        reasonList: [] //原因列表
      },
      radioChooseEvidence: '',
      navTitle: ''
    }
  },
  components: {
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar
  },
  computed: {
    isMainPage() {
      return this.$route.name == 'choosereason'
    }
  },
  //全局信息和方法
  provide() {
    return {
      sharedData: this.sharedData, //共享数据
      submitData: this.submitData, //最后提交的数据
      mergeSubmitData: this.mergeSubmitData, //合并提交数据方法
      setNavTitle: this.setNavTitle,
      radioChooseEvidence: () => this.radioChooseEvidence,
      setRadioChooseEvidence: this.setRadioChooseEvidence
    }
  },
  methods: {
    mergeSubmitData(params = {}) {
      Object.assign(this.submitData, params)
    },
    setRadioChooseEvidence(val) {
      this.radioChooseEvidence = val
    },
    //加载原因
    loadReasonList() {
      return new Promise((resolve) => {
        const tree = JSON.parse(window.sessionStorage.getItem(`reason_list${this.sharedData.from}`))
        if (tree) {
          console.log('got reason list from SessionStorage.')
          resolve(tree)
        } else {
          console.log('start fetch reason list...')
          getreportreasons({
            from: this.sharedData.from
          }).then((data) => {
            const res = formatReason(data, this.sharedData.from)
            window.sessionStorage.setItem(`reason_list${this.sharedData.from}`, JSON.stringify(res))
            resolve(res)
          })
        }
      })
    },
    setNavTitle(val) {
      this.navTitle = val
    },
    handleClickLeft() {
      if (this.isMainPage) {
        native.close()
      } else {
        this.$router.back()
      }
    }
  },
  async mounted() {
    this.loadReasonList().then(res => {
      this.sharedData.reasonList = res
      this.mergeSubmitData(this.sharedData)
      delete this.submitData.reasonList
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
